<template>
    <div class="alert-schedule"
    :style="{
        background: colors.theme == 'dark' ? `#f6f6f6` : `#f6f6f6`,
        color: colors.theme == 'dark' ? `#000` : `#000`,
    }"    
    >
        <div class="schedule-container">
            <div class="image-schedule"
            :style="{
                background: colors.theme == 'dark' ? `#fff` : `#fff`,
                color: colors.theme == 'dark' ? `#000` : `#000`,
            }"       
            >
                <!-- <img class="img-schedule" src="../../assets/schedule-success.png" alt=""> -->
                <SessionScheduled></SessionScheduled>
            </div>
            <div class="message-schedule">
                <span class="message"
                :style="{
                    color: colors.theme == 'dark' ? `#000` : `#000`,
                }"  
                >
                    {{$t("components.Alerts.AlertSchedule.message[0]")}}
                        <span class="date"
                        :style="{
                            color: colors.secondary,
                        }"  
                        >{{ date }}</span>
                    {{$t("components.Alerts.AlertSchedule.message[1]")}}
                        <span class="time"
                        :style="{
                            color: colors.secondary,
                        }"     
                        >{{ time }}</span>
                    <!-- (horário de brasília) -->
                </span>
            </div>
            <div class="rules"
            :style="{
                color: colors.theme == 'dark' ? `#4d4c4c` : `#4d4c4c`,
            }"  
            >
                <p class="rule-title">
                    {{$t("components.Alerts.AlertSchedule.title")}}
                </p>
                <span class="rule-text">
                    {{$t("components.Alerts.AlertSchedule.ruleMessages[0]")}}<span class="minutes"> {{$t("components.Alerts.AlertSchedule.ruleMessages[1]")}}</span>
                    {{$t("components.Alerts.AlertSchedule.ruleMessages[2]")}}
                </span>
            </div>
            <div class="rules"
            :style="{
                color: colors.theme == 'dark' ? `#4d4c4c` : `#4d4c4c`,
            }"     
            >
                <p class="rule-title">
                    {{$t("components.Alerts.AlertSchedule.ruleMessages[3]")}}
                </p>
                <span class="rule-text">
                    {{$t("components.Alerts.AlertSchedule.ruleMessages[4]")}} 
                    <span class="minutes">{{$t("components.Alerts.AlertSchedule.ruleMessages[5]")}}</span>{{$t("components.Alerts.AlertSchedule.ruleMessages[6]")}}
                </span>
            </div>
            <div class="button-alert" @click="closeAlert()" @touch="closeAlert()">
                <button-simple 
                    :textButton='$t("components.Alerts.AlertSchedule.textButton")' 
                    :action="false"
                    color="#fff581"></button-simple>
            </div>
        </div>
        
    </div>
</template>
<script>
import ButtonSimple from '../Buttons/ButtonSimple.vue'
import SessionScheduled from "../Shared/CustomIcons/Alert/SessionScheduled.vue"
export default {
    components: {
        ButtonSimple, SessionScheduled
    },
    props: {
        date : {
            type : String,
            required : true
        },
        time : {
            type : String,
            required : true
        }
    },
    methods: {
        closeAlert(){
            this.$emit('closeAlert')
        }
    },
    created(){
        this.colors = JSON.parse(localStorage.getItem("colors"));
    },
    data(){
        return{
            colors:{}
        }
    },      
}
</script>
<style lang="scss" scoped>
    .alert-schedule{
        display: flex;
        flex-direction: column;
        height: 100vh;
        width: 100%;
        justify-content: flex-end;
        position: absolute;
        top: 0%;
        background-color: #2f353a;
        text-align: center;
        z-index: 1002;

        .schedule-container{
            width: 80%;
            margin: 0 auto;
            height: calc( 100vh - 60px );
            display: flex;
            flex-direction: column;
            justify-content: center;
            margin-bottom: 15%;

            .image-schedule{

                padding: 14% 11%;
                background-color: #2a2f34;
                border-radius: 50%;
                margin: 4% auto;

                svg{
                    width: 180px;
                }

                .img-schedule{
                    height: 150px;
                    margin-left: 5%;
                }
            }

            .message-schedule{

                width: 101%;
                margin: 0 auto;

                .message{

                    font-size: 30px;
                    text-transform: uppercase;
                    font-weight: 800;
                    position: relative;
                    bottom: 55px;

                    .date, .time{
                        font-weight: bold;
                    }
                }
            }

            .rules{

                color: white;
                font-size: 16px;
                width: 80%;
                margin: 0 auto;
                margin-bottom: 10%;

                .rule-title, .minutes{

                    font-weight: bold;
                }
            }
        }

        .button-alert{
            height: 60px;
            bottom: 0;
            width: 100%;
            max-width: 220px;
            margin: 32px auto 0px;
        }
    }

    @media only screen and (min-width : 750px){
        .alert-schedule{
            height: 100%;

            .schedule-container{

                height: 100%;
                margin-bottom: 0%;

                .image-schedule{

                    padding: 0;
                    width: 230px;
                    height: 230px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                .message-schedule {

                    margin-bottom: 5%;
                    font-size: 25px;
                }

                .rules{

                    margin-bottom: 5%;
                    font-size: 14px;
                }
            } 

            .button-alert{
                height: 120px;
                position: initial;
            }
        }
    }
</style>
